import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

import { AuditService } from '@services/audit.service';

const TAG = 'TaInputComponent ';

@Component({
    selector: 'app-ta-input',
    templateUrl: 'ta-input.html',
    styleUrls: ['ta-input.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TaInputComponent extends FieldType implements OnInit {

    private updatedKey: string;
    private fullInputString: string = '';

    public isDebug = false;
    public disableClear = false;
    public invalidNumber = false;
    public invalidDecimal = false;

    constructor(
        private auditService: AuditService
    ) {
        super();
    }

    public ionInput(event) {
        if (event.detail.event.inputType === 'deleteContentBackward') {
            if (this.fullInputString.length > 0) {
                this.fullInputString = this.fullInputString.substring(0, this.fullInputString.length - 1);
            }
        } else if (event.detail.event.inputType === 'insertText') {
            if (event.detail.event.data === "-") {
                this.fullInputString = this.fullInputString + event.detail.event.data;
            } else {
                this.fullInputString = this.fullInputString + event.detail.event.data;
            }
        }

        if (this.props.inputmode === 'numeric') {
            if (this.fullInputString.lastIndexOf('.') !== -1) {
                this.invalidNumber = true;
            } else if (this.fullInputString.lastIndexOf('-') !== -1 && this.fullInputString.lastIndexOf('-') !== 0) {
                this.invalidNumber = true;
            } else {
                this.invalidNumber = false;
            }
        } else if (this.props.inputmode === 'decimal') {
            if (this.fullInputString.lastIndexOf('-') !== -1 && this.fullInputString.lastIndexOf('-') !== 0) {
                this.invalidDecimal = true;
            } else {
                this.invalidDecimal = false;
            }
        }

    }

    ngOnInit() {
        const METHOD = 'ngOnInit';
        console.log(TAG + METHOD);
        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }
        if (this.formControl.value) {
            this.fullInputString = this.formControl.value + '';
        }
    }

    public clear() {
        const METHOD = 'clear';
        console.log(TAG + METHOD);
        this.formControl.reset(null);
        this.auditService.unsetLocationAndTimestamp(this.updatedKey);
        if (this.model.audit_type === 'Register Item Checklist') {
            if (this.updatedKey === 'data.section_0.question_1.findings.value') {
                this.model.register_item_id = null;
            }
        }
    }

    public integerValuesOnly(event: any) {
        /*
         * Note: On Android the '.' and '-' characters do not register as a keypress events
         */
        const METHOD = 'integerValuesOnly';
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }

    public decimalValuesOnly(event: any) {
        /*
         * Note: On Android the '.' and '-' characters do not register as a keypress events
         */
        const METHOD = 'decimalValuesOnly';
        const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57) && !(charCode === 46 || charCode === 108 || charCode === 110)) {
            event.preventDefault();
        } else if (charCode === 46 || charCode === 108 || charCode === 110) {
            if (this.fullInputString.length === 0 || this.fullInputString.indexOf('.') !== -1) {
                event.preventDefault();
            }
        }
    }

}
